import React from "react";
import Seo from "../components/Seo";
import Footer from "../components/Footer";
import Hero from "../components/Heros/HeroContact";

const ContactIntro = () => (
    <>
        <Seo
            title="Contact Us"
            description="프로젝트 문의부터 파트너십까지, 케이유융합소프트웨어연구센터에 편하게 연락 주세요."
            path="/contact-intro"
        />
        <Hero />
        <section className="py-section">
            <div className="container mx-auto space-y-8 px-5 xl:px-0">
                <div className="space-y-2 text-center">
                    <h2 className="text-h1 font-bold">
                        Contact US
                    </h2>
                </div>
                <div className="mx-auto grid max-w-2xl grid-cols-1 justify-items-center gap-10 md:grid-cols-2">
                    <a className="w-full max-w-md text-center" href="/recruit/jobs">
                        <img
                            className="mx-auto h-52 w-full rounded-2xl object-cover object-center"
                            src="/img/recruit_img_01.jpg"
                        />
                        <div className="mt-4">
                            <h3 className="text-lead font-semibold text-gray-900">
                                채용지원
                            </h3>
                        </div>
                    </a>
                    <a className="w-full max-w-md text-center" href="/contact">
                        <img
                            className="mx-auto h-52 w-full rounded-2xl object-cover object-center"
                            src="/img/contact-us-03.jpg"
                        />
                        <div className="mt-4">
                            <h3 className="text-lead font-semibold text-gray-900">
                                사업문의
                            </h3>
                        </div>
                    </a>
                </div>
            </div>
        </section>
        <Footer />
    </>
);

export default ContactIntro;
